import cookie from '../cookie'
import { canUseDOM, isAuthenticated } from '@common/utils'

export default class Cart {
  constructor(api) {
    this.api = api
  }

  getCart = async (opts = {}) => {
    const res = await this.api.get('/GetCart', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      mock: 'getCart.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  getProducts = async (opts = {}) => {
    const res = await this.api.get('/GetProducts', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader(opts ? opts.req : undefined)
      },
      mock:
        opts.params && !opts.params.stock
          ? 'getProducts.json'
          : 'getProductsWithStocks.json'
    })
    if (canUseDOM && res && res.auth_token) {
      cookie.setToken(res.auth_token)
    }
    return res
  }

  getDevicesBundles = async (opts = {}) => {
    const res = await this.api.get('/GetBundles', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader(opts ? opts.req : undefined)
      },
      mock:
        opts.params && !opts.params.stock
          ? 'productBundleList.json'
          : 'productBundleListWithStocks.json'
    })
    if (canUseDOM) {
      cookie.setToken(res.auth_token)
    }
    return res
  }

  getStockNotification = async product => {
    const res = await this.api.get('/catalogue/stocknotification', {
      params: { productid: parseInt(product.id, 10) },
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: 'stocknotification.json'
    })
    return res
  }

  addStockNotification = async (
    userInfo,
    productId,
    selectedOption,
    recaptcha
  ) => {
    const data = userInfo
      ? {
          name: userInfo.name,
          email: userInfo.email,
          token: recaptcha.token,
          action: recaptcha.action,
          productId: parseInt(productId, 10),
          productOption: {
            optionId: selectedOption.optionId,
            variantId: selectedOption.variantId
          }
        }
      : {
          productId: parseInt(productId, 10),
          productOption: {
            optionId: selectedOption.optionId,
            variantId: selectedOption.variantId
          }
        }
    const res = await this.api.post('/catalogue/stocknotification', {
      data: data,
      headers: isAuthenticated()
        ? {
            ...cookie.authorizationTokenHeader()
          }
        : {}
    })
    return res
  }

  addToCart = async (products, cartType, qureProduct) => {
    let res
    if (Array.isArray(products) && products.length) {
      const CartType = cartType
      const QureProduct = qureProduct
      res = await this.api.post('/AddToCart', {
        headers: {
          ...cookie.authorizationTokenHeader(null, false, true)
        },
        withCredentials: true,
        useProxy: true,
        data: {
          CartProducts: products.map(p => {
            const product = {
              ...p.opts,
              ProductId: parseInt(p.id, 10),
              Amount: parseInt(p.qty, 10)
            }
            if (p.option) {
              product.ProductOptions = {
                OptionId: p.option.optionId,
                VariantId: p.option.variantId
              }
            }
            if (p.chainId) {
              product.ChainId = parseInt(p.chainId, 10)
            }
            if (p.options) {
              product.ProductOptions = {
                OptionId: p.options.optionId,
                VariantId: p.options.variantId
              }
            }
            return product
          }),
          ...(CartType && { CartType }),
          ...(QureProduct && { QureProduct })
        },
        mock: 'addToCart.json'
      })
      cookie.setToken(res.auth_token)
    }
    return res
  }

  updateCart = async (
    ProductId,
    Amount,
    ProductOptions,
    newVariantId,
    chainId,
    cartType
  ) => {
    const option = ProductOptions && {
      OptionId: ProductOptions[0].optionId,
      VariantId: ProductOptions[0].variantId
    }
    const new_variant = newVariantId
    const ChainId = chainId ? parseInt(chainId, 10) : undefined
    const CartType = cartType
    const res = await this.api.post('/UpdateCart', {
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      data: {
        ProductId: parseInt(ProductId, 10),
        Amount: parseInt(Amount, 10),
        ProductOptions: option && option,
        ...{ ChainId },
        ...{ new_variant },
        ...(CartType && { CartType })
      },
      mock: 'updateCart.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  addCoupon = async couponCode => {
    const res = await this.api.post('/AddCoupon', {
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      data: {
        CouponCode: couponCode
      },
      mock: 'addCoupon.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  removeCoupon = async couponCode => {
    const res = await this.api.post('/RemoveCoupon', {
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      data: {
        CouponCode: couponCode
      },
      mock: 'removeCoupon.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  removeFromCart = async (productId, cartType) => {
    const CartType = cartType
    const res = await this.api.post('/DeleteFromCart', {
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      data: {
        ItemId: parseInt(productId, 10),
        ...(CartType && { CartType })
      },
      mock: 'deleteFromCart.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  placeOrder = async (
    PaymentId,
    fingerPrint,
    paymentMethod,
    additionalData,
    checksum,
    cartType,
    updateDefaultAddress
  ) => {
    const PaymentMethod = paymentMethod
    const AdditionalData = additionalData
    const CartType = cartType
    const res = await this.api.post('/PlaceOrder', {
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      withCredentials: true,
      useProxy: true,
      data: {
        PaymentId: parseInt(PaymentId, 10),
        FingerPrint: fingerPrint,
        Checksum: checksum,
        ...(PaymentMethod && { PaymentMethod }),
        ...(AdditionalData && { AdditionalData }),
        ...(CartType && { CartType }),
        ...(updateDefaultAddress && { updateDefaultAddress })
      },
      mock: 'placeOrder.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  payOrder = async (status, checksum, error, cartType) => {
    const cart_type = cartType
    const res = await this.api.post('/order/payment', {
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      data: {
        status: status,
        checksum: checksum,
        error: error,
        ...{ cart_type }
      },
      mock: 'payOrder.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  getCheckoutData = async (opts = {}) => {
    const res = await this.api.get('/GetCheckoutData', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      mock: 'getCheckoutData.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  setCheckoutData = async (data, cart) => {
    const cartType = cart
    const res = await this.api.post('/SetCheckoutData', {
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      data: {
        ...data,
        ...{ cartType }
      },
      mock: 'setCheckoutData.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  verifyPasswordForTobaccoOrder = async data => {
    const res = await this.api.post('/account/password/verification', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data
    })
    cookie.setToken(res.auth_token)
    return res
  }

  getRelatedProducts = async (opts = {}) => {
    const res = await this.api.get('/RelatedProducts', {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader(opts ? opts.req : undefined)
      },
      mock: 'relatedProducts.json'
    })
    if (canUseDOM && res && res.auth_token) {
      cookie.setToken(res.auth_token)
    }
    return res
  }

  getUpgradeOfferProducts = async (offerid, opts = {}) => {
    const res = await this.api.get('/GetUpgradeOfferProducts/' + offerid, {
      ...opts,
      headers: {
        ...cookie.authorizationTokenHeader(opts ? opts.req : undefined)
      },
      mock: 'getUpgradeOfferProducts.json'
    })
    if (canUseDOM && res && res.auth_token) {
      cookie.setToken(res.auth_token)
    }
    return res
  }

  getSurveyLinks = async data => {
    const res = await this.api.post('/survey/buildsurveylinks', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data,
      mock: 'getSurveyLinks.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  getPickupAreas = async (items, orderType) => {
    const res = await this.api.post('/order/pickup/areas', {
      headers: {
        'Content-type': 'application/json',
        ...cookie.authorizationTokenHeader()
      },
      data: {
        items: items,
        orderType: orderType
      },
      mock: 'getPickupAreas.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  getPickupStores = async data => {
    const res = await this.api.post('/order/pickup/stores', {
      headers: {
        'Content-type': 'application/json',
        ...cookie.authorizationTokenHeader()
      },
      data: {
        ...data
      },
      mock: 'getPickupStores.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  getDeliveryDatelist = async (items, orderType, postalCode) => {
    const res = await this.api.post('/order/delivery/list', {
      headers: {
        'Content-type': 'application/json',
        ...cookie.authorizationTokenHeader()
      },
      data: {
        items: items,
        orderType: orderType,
        zipCode: postalCode
      },
      mock: 'deliveryDateList.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  shortestDelivery = async items => {
    const res = await this.api.post('/order/delivery/shortest', {
      headers: {
        'Content-type': 'application/json',
        ...cookie.authorizationTokenHeader()
      },
      data: {
        orderType: 'EC',
        items
      },
      mock: 'shortestDelivery.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  externalCampaign = async (token, ecc) => {
    const res = await this.api.post('/cart/externalcampaign', {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      data: {
        ecc
      }
    })
    cookie.setToken(res.auth_token)
    return res
  }

  deleteCreditCard = async id => {
    const res = await this.api.delete('/payment/card/' + id, {
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      mock: 'deleteCreditCard.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }

  editCreditCard = async (id, data) => {
    const res = await this.api.put('/payment/card/' + id, {
      data,
      headers: {
        ...cookie.authorizationTokenHeader(null, false, true)
      },
      mock: 'editCreditCard.json'
    })
    cookie.setToken(res.auth_token)
    return res
  }
}
